module.exports = __webpack_public_path__ + "static/media/fassb-header.b259d290.png";